import { Component, OnInit, Inject, Input } from '@angular/core';
import { WorkspaceServiceService } from '../../services/workspace-service.service';
import {FaqComponent} from '../faq/faq.component';
import {Utils} from '../../utils';

export type Video = { id: number, name: string, wistiaId: string, categoryId: number};
export type FAQ = { id: number, question: string, answer?: string, expandAction?: () => void, seeMoreText?: string, seeMoreAction?: () => void, hideAction?: () => void};

@Component({
  selector: 'tutorial-panel',
  template: require('./tutorial-panel.component.html'),
  styles: [require('./tutorial-panel.component.css')]
})
export class TutorialPanelComponent implements OnInit {

  get tutorialVideoWindow()
  {
    return this.workspaceService.data.tutorialVideoWindow;
  }

  get shown()
  {
    return this._shown;
  }

  set shown(value)
  {
    if(value)
      this.preloadVideos();

    this._shown = value;

   // if(this.workspaceService.data.tutorialPanelShown!=value)
    //this.workspaceService.data.tutorialPanelShown = value;
    
  }

  _shown = false;

  get activeCategoryId()
  {
    return this._activeCategoryId;
  }

  set activeCategoryId(v)
  {
    if(this._activeCategoryId == v)
      return;
    
    if(this._activeCategoryId == 4)
      FaqComponent.closeAll.next();

    this._activeCategoryId = v;
  }

  _activeCategoryId = 1;

  categories: {id: number, name: string}[] = 
  [
    {id: 1, name: 'Fast Track'},
    {id: 2, name: 'Desktop'},
    {id: 3, name: 'Mobile'},
    {id: 4, name: 'FAQ'}
  ]

  videos: Video[] =
  [
    //Your education (categoryId: 1): 
    { id: 1, name: 'Watch This First', wistiaId: 'egbnksvisn', categoryId: 1},
    { id: 2, name: 'Quick Start', wistiaId: 'wa3aqbaede', categoryId: 1},
    { id: 3, name: 'Price Points Strategy', wistiaId: 'phfehglze8', categoryId: 1},
    { id: 4, name: 'Support & Resistance', wistiaId: 'mf4ocokhrn', categoryId: 1},
    { id: 5, name: 'Stops and Limits', wistiaId: '8k2dalwt4p', categoryId: 1},
    { id: 6, name: 'Risk / Reward', wistiaId: 'hkk8qfcetu', categoryId: 1},

    //Video library (categoryId: 2): 
    {'id':8,'name':'Menu','wistiaId':'npututros9','categoryId':2},
    {'id':9,'name':'Control Panel','wistiaId':'xbsgy4rgvu','categoryId':2},
    {'id':10,'name':'Wizard, Chart, Signals', 'wistiaId':'ss8rf5zvkr','categoryId':2},
    {'id':11,'name':'Momentum, Vol, B&S','wistiaId':'tiqdp5wjzb','categoryId':2},

    //Mobile (categoryId: 3):
    {'id':12,'name':'Home Screen','wistiaId':'pnqny11pt2','categoryId':3},
  ]

  get showWhatIsForex()
  {
    return this._showWhatIsForex;
  }

  set showWhatIsForex(v)
  {
    if(v && this.workspaceService.data.mobileMode != 'desktop')
      Utils.openPopup('/faq-assets/what-is-forex-faq-more.png', 'What is the Forex?', 750, 550);
      
    this._showWhatIsForex = v;
  }
  _showWhatIsForex = false;

  faqs: FAQ[] = 
  [
    {
      id: 1, 
      question: 'What is the Forex?', 
      answer: 'The Foreign Exchange Market better know as the FOREX is the world’s largest market with an estimated daily turnover of $1.5 Trillion dollars. This is 30 times larger than all the US stock markets combined. It is the exchange of one currency for another.Participants are capitalizing on the fluctuation in exchange rates.',
      seeMoreText: 'Click here for Example',
      seeMoreAction: () => this.showWhatIsForex = true,
      hideAction: () => this.showWhatIsForex = false
    },
    {
      id: 2, 
      question: 'Forex 101', 
      expandAction: () => Utils.openPopup('/faq-assets/forex-101-faq.pdf', 'Forex 101', 750, 550)
    },
    {
      id: 3, 
      question: 'Terms & Phrases', 
      expandAction: () => Utils.openPopup('/faq-assets/terms-and-phrases-faq.pdf', 'Terms & Phrases', 750, 550)
    },
    {
      id: 4, 
      question: 'What are Candlesticks?', 
      answer: 'Candlesticks are colored accordingly to the direction of price movement: when the open rate is higher than the closing rate the candlestick is colored in red; when the open rate starts lower than the closing rate the candlestick is colored in green.\
\
      The body of the candlestick, also called the “real” body, represents the range between the open and closing prices. ',
      seeMoreText: 'Click to View Candlestick Patterns',
      seeMoreAction: () => Utils.openPopup('/faq-assets/candlesticks-faq-see-more.jpg', 'What are Candlesticks?', 750, 550)
    },
    {
      id: 5,
      question: 'Can I Do Live Trading on PremiereTrade?',
      answer: 'Yes, click the “Open Live Account” tab located in the bottom left of the screen to open a live account.',
      seeMoreText: 'Internal directions',
      seeMoreAction: () => Utils.openPopup('/faq-assets/open-live-account-faq-more.png', 'Can I Do Live Trading on PremiereTrade?', 750, 550)
    },
    {
      id: 6,
      question: 'How Can I See My Trade Desk?',
      answer: 'The Trade Desk Tile is on the home Tile Page. The Trade Desk shortcut icon is located at the top right portion of the scree and is accessible at all times.',
      seeMoreText: 'Internal directions',
      seeMoreAction: () => Utils.openPopup('/faq-assets/tradedesk-faq-more.png', 'How Can I See My Trade Desk?', 750, 550)
    },
    {
      id: 7,
      question: 'What is the App Store and How Do I Open It?',
      answer: 'The App Store is where users can select customized proprietary tools to use that make trading and finding trends easier. \
      The App Store Tile is on the home Tile Page. The App Store shortcut icon is located at the top right portion of the scree and is accessible at all times.',
      seeMoreText: 'Internal directions',
      seeMoreAction: () => Utils.openPopup('/faq-assets/appstore-faq-more.png', 'What is the App Store and How Do I Open It?', 750, 550)
    },
    {
      id: 8,
      question: 'How Do I Enter An Upcoming Challenge?',
      answer: 'Visit the Challenge tab and then select the Upcoming challenges section. Click the details button of any challenge, then press Join.',
      seeMoreText: 'Internal directions',
      seeMoreAction: () => Utils.openPopup('/faq-assets/challenges-faq-more.png', 'How Do I Enter An Upcoming Challenge?', 750, 550)
    },
    {
      id: 9,
      question: 'Can I enter a Challenge that has already started?',
      answer: 'Yes. Visit the Challenge tab and then select the Leaderboard section. Click the Enter button and Join.',
      seeMoreText: 'Internal directions',
      seeMoreAction: () => Utils.openPopup('/faq-assets/already-started-challenge-faq-more.png', 'How Do I Enter An Upcoming Challenge?', 750, 550)
    },
    {
      id: 10,
      question: 'When do I receive my winnings from a challenge?',
      answer: 'It typically takes 30 days to process challenge results. Funds are mailed out then.'
    }
  ]
  
  get filteredVideos()
  {
    return this.videos.filter(v => v.categoryId == this.activeCategoryId);
  }

  

  constructor(protected workspaceService: WorkspaceServiceService) { workspaceService.data.tutorialPanel = this; }

  ngOnInit() {
    
  }

  preloadVideos() {
    if(this.tutorialVideoWindow && (this.tutorialVideoWindow.videos == null || this.tutorialVideoWindow.videos.length < 1))
      this.tutorialVideoWindow.videos = this.videos.map(v => v.wistiaId);
  }

  isVideoWatched(video: Video)
  {
    return this.workspaceService.data.watchedVideos.indexOf(video.wistiaId) !== -1;
  }
}
